module.exports = __webpack_public_path__ + "img/78.8f4c2f5f.jpg";